module.exports = __webpack_public_path__ + "img/drawing.5fc8894f.png";